import { format } from "date-fns";
import { useDispatch } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { ROUTES } from '../../../../../routes';
import { useNavigate } from "react-router-dom";
import styles from "./CardSettings.module.scss";
import Button from "../../../../common/Button/Button";
import CommonCardStbl from "../CommonCardStbl/CommonCardStbl";
import NoContent from "../../../../common/NoContent/NoContent";
import { AlertCircle, CardIcon, DocIcon, GreenArrowIcon, RedArrowIcon } from "../../../../../assets/icons/svgicons";
import { cardDataAction, cardDetailsAction, cardTranstionAction, getCardStatementAction } from "../../../../../features/user/userSlice";
import Table from "../../../../common/Table/Table";

const CardSettings = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const cardType = localStorage.getItem("cardType");
    const [cardDetails, setCardDetails] = useState({});
    const [cardData, setCardData] = useState({
        rain_card_id: '',
        last_four: '0000',
        expiry_month: "00",
        expiry_year: "0000",
        status: '',
        currentMonthSpending: 0,
        balance: {
            balance: '0.00',
            card_limit: 0,
            spent_limit: 0,
        },
        application: {
            first_name: '***',
            last_name: '***',
        },
    })
    const [creditData, setCreditData] = useState(null)
    const [transactionData, setTransactionData] = useState([]);

    const Data = [
        {
            classcard: "",
            label: "Total amount Due",
            values: "$" + creditData?.new_balance || 0,
            description: "",
        },
        {
            classcard: "light_blue",
            label: "Amount Paid",
            values: "$" + creditData?.total_payments || 0,
            description: "",
        },
        {
            classcard: "light_red",
            label: "Payment Date",
            values: cardData?.payment_due_date ? format(new Date(cardData?.payment_due_date), "dd MMM, yyyy") : "--",
            description: "",
        },
    ];

    // ********** GET CARD DETAILS **********
    const getCardDetails = async () => {
        try {
            const res = await dispatch(cardDetailsAction());
            if (res?.status === 200) {
                const cards = res?.data?.data || [];
                const debit = cards.find((c) => c.card_type === "DEBIT");
                const credit = cards.find((c) => c.card_type === "CREDIT");
                setCardDetails({ debit: debit, credit: credit })
            } else {
                setCardDetails({});
            }
        } catch (error) {
            console.log(error, "error");
        }
    }
    const cardId = cardType === "CREDIT" ? cardDetails?.credit?.rain_card_id : cardDetails?.debit?.rain_card_id;


    const cardDetailsData = async () => {
        if (!cardId) return;
        try {
            const res = await dispatch(cardDataAction(cardId));
            if (res.status === 200) {
                setCardData(res?.data?.data);
            }
        } catch (error) {
            console.log("Error");
        }
    };

    const cardTranstionData = async () => {
        if (!cardId) return;
        try {
            const res = await dispatch(cardTranstionAction(cardId));
            if (res.status === 200) {
                const fullList = res?.data?.data || [];
                const topFive = fullList?.transactions?.slice(0, 5);
                const topTen = fullList?.transactions?.slice(0, 8);
                setTransactionData(cardType === "CREDIT" ? topFive : topTen);
            }
        } catch (error) {
            console.log("Error");
        }
    };
    useEffect(() => {
        getCardDetails()
        if (cardId) {
            cardDetailsData()
            cardTranstionData()
        }
    }, [cardId])

    const totalLimit = cardData?.balance?.card_limit || 0;
    const usedLimit = cardData?.balance?.spent_limit || 0;

    const percentage = Math.min((usedLimit / totalLimit) * 100, 100);

    const getCardStatement = async () => {
        if (!cardId) return;
        try {
            const res = await dispatch(getCardStatementAction({}, cardId))
            if (res?.status === 200) {
                setCreditData(res?.data?.data)
            }
        } catch (error) {
            console.log(error, "error");
        }
    }
    useEffect(() => {
        if (cardId) {
            getCardStatement()
        }
    }, [cardId])

    const fields = [
        { label: "Transaction Id", value: "amount" },
        { label: "Amount", value: "bill_number" },
        { label: "Transaction Status", value: "paid_amount" },
        { label: "Type", value: "paid_amount" },
        { label: "Date & Time", value: "previous_balance" },
    ]

    return (
        <>
            <section className={styles.cardSetting}>
                <Row className="moneyrows">
                    <Col lg={4} className="moneyleftcard">
                        <div className={styles.cardSetting_left}>
                            {
                                cardType === "CREDIT" ? <>
                                    <div className={styles.cardSetting_left_head}>
                                        <div className={styles.head_left}>
                                            <p>Available Credit Limit</p>
                                            <h5>${cardData?.balance?.balance || 0}</h5>
                                        </div>
                                        <div className={styles.head_right}>
                                            <p>Total Credit Limit: ${cardData?.balance?.card_limit || 0}</p>
                                            <p>Limit Utilised: ${cardData?.balance?.spent_limit || 0}</p>
                                        </div>
                                    </div>
                                    <div className={styles.progressbar}>
                                        <div
                                            className={styles.progressbar_fill}
                                            style={{ width: `${percentage}%` }}
                                        ></div>
                                    </div>
                                </>
                                    :
                                    <>
                                        <div className={styles.cardSetting_left_head}>
                                            <div className={styles.head_left}>
                                                <p>Available Balance</p>
                                                <h5>${`${cardData?.balance?.balance}`}</h5>
                                            </div>

                                        </div>
                                        <div className={styles.progressbar}>
                                            <div
                                                className={styles.progressbar_fill}
                                                style={{ width: "100%" }}
                                            ></div>
                                        </div>
                                    </>
                            }
                            <div className={styles.multiCards}>
                                <CommonCardStbl
                                    cardstatus={cardData?.card_form}
                                    cardType={cardType}
                                    cardNumber={`**** **** **** ${cardData?.last_four}`}
                                    cardName={`${cardData?.application?.first_name} ${cardData?.application?.last_name}`}
                                    cardDate={`${cardData?.expiry_month}/${cardData?.expiry_year}`}
                                />
                            </div>
                            <div className={styles.action_box}>
                                <h3 className="big">Spend your gold anywhere with STBL Visa</h3>
                                <h5>Convert your precious metals to spending power instantly</h5>
                                <div className={styles.action_box_btn}>
                                    {cardType === "CREDIT" &&
                                        <Button className={styles.btn_size} onClick={() => navigate(ROUTES.CARD_STATEMENT)}>
                                            <span><DocIcon /></span>
                                            Account Details
                                        </Button>}
                                    <Button
                                        className={styles.btn_size}
                                        variant='bordered_white'
                                        onClick={() => navigate(ROUTES.MANAGE_CARD)}
                                    >
                                        <span><CardIcon /></span>
                                        Manage Card
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={8} className="moneyrightcard">
                        <div className={styles.cardSetting_right}>
                            {
                                cardType === "CREDIT" ?
                                    creditData ?
                                        <>
                                            <h4 className={styles.heading}>
                                                Summary of last statement, dated {cardData?.billing_date || ""}
                                            </h4>
                                            <div className={styles.cardSetting_right_head}>
                                                <Row>
                                                    {Data.map((items, index) => (
                                                        <Col xxl={3} xl={3} lg={3} md={4} sm={6} xs={12} key={index} className="card_col">
                                                            <div
                                                                className={`${styles.cardtransaction} ${items.classcard}`}
                                                            >
                                                                <div className={styles.text_sec}>
                                                                    <label>{items.label}</label>
                                                                    <h4 className="big">{items.values}</h4>
                                                                    <p>{items.description}</p>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </div>
                                        </> :
                                        <div className={styles.cardSetting_right_head}>
                                            <Row>
                                                <Col xxl={3} xl={3} lg={3} md={4} sm={6} xs={12} className="card_col">
                                                    <div className={`${styles.cardnotyet}`}>
                                                        <div className={styles.text_sec}>
                                                            <h4 className="big">  <AlertCircle /> Bill Not Yet Generated</h4>
                                                            <label>Your bill is being prepared and will be available soon.</label>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    : null
                            }
                            <div className={styles.recent_transactions}>
                                <div className={styles.recent_transactions_head}>
                                    <h2>Recent transactions</h2>
                                    <Button
                                        className={styles.common_btn}
                                        onClick={() => {
                                            localStorage.setItem("cardType", cardType);
                                            navigate(ROUTES.RECENT_TRANSACTIONS)
                                        }}
                                    >View all
                                    </Button>
                                </div>
                                &nbsp;
                                <Table
                                    noRecordContent={"No records for your search were found."}
                                    fields={fields}
                                    className='table'
                                    // loading={loading}
                                    noRecordVariant={"large"}
                                    noRecordClassName={styles.no_content}
                                    loadingClassName={"loading_table"}
                                >
                                    {transactionData?.length > 0 ?
                                        transactionData?.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    {item?.external_transaction_id
                                                        ? item.external_transaction_id
                                                        : item?.id}
                                                </td>
                                                <td>
                                                    {item?.amount}
                                                    &nbsp;
                                                    <span>{item?.transaction_type_api === "spend" ? <RedArrowIcon /> : <GreenArrowIcon />}</span>
                                                </td>
                                                <td>{item?.transaction_status}</td>
                                                <td>{item?.transaction_type_api === "load" ? "Top Up" : "Spend"}</td>
                                                <td>{item?.created_at &&
                                                    !isNaN(
                                                        new Date(item?.created_at).getTime()
                                                    )
                                                    ? format(
                                                        new Date(item?.created_at),
                                                        "dd MMM, yyyy hh:mm a"
                                                    )
                                                    : "Invalid date"}</td>
                                            </tr>
                                        )) :
                                        <tr>
                                            <td colSpan={fields.length}>
                                                <NoContent
                                                    className={styles.no_record}
                                                />
                                            </td>
                                        </tr>
                                    }
                                </Table>
                            </div>
                        </div>
                    </Col>
                </Row>
            </section>
        </>
    )
}

export default CardSettings